export default [{
  path: '/home',
  name: 'home',
  meta: { requiresAuth: true },
  component: () => import('@/layouts/MainTemplate'),
  children: [{ path: '', component: () => import('@/views/Home/Index') }]
}]
